/* eslint-disable no-unused-vars */
import { IGetApiRequestParams, ILooseObject } from '@/src/types/common.interface';
import AppUtils from '@/src/utils/AppUtils';

export enum ALL_POLICY_URLS_ENUM {
  GET_ALL_POLICY_LIST = 'GET_ALL_POLICY_LIST',
  CREATE_NEW_POLICY = 'CREATE_NEW_POLICY',
  EXECUTE_POLICY = 'EXECUTE_POLICY'
}

type GET_POLICY_API_URL_TYPE = IGetApiRequestParams & {
  url: ALL_POLICY_URLS_ENUM;
  data?: ILooseObject;
};

abstract class AllPolicy {
  public static GetPolicyApiUrl({
    url,
    data,
    filters,
    pagination,
    sorting
  }: GET_POLICY_API_URL_TYPE) {
    switch (url) {
      case ALL_POLICY_URLS_ENUM.GET_ALL_POLICY_LIST:
        return AppUtils.formatGetApiParameters(
          `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/application/${data?.applicationKey}/policy`,
          { pagination, sorting, filters }
        );

      case ALL_POLICY_URLS_ENUM.CREATE_NEW_POLICY:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/application/${data?.applicationKey}/policy`;

      case ALL_POLICY_URLS_ENUM.EXECUTE_POLICY:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/policy/test`;

      default:
        return '';
    }
  }
}

export default AllPolicy;
